import {GtmBaseEvent, CustomerData} from '@/store/models';
import store from '@/store';
import {getCustomerSections} from '@/store/api';
import to from 'await-to-js';

async function getLocalStorageCustomer() {
    const mageCacheStorage = JSON.parse(localStorage.getItem('mage-cache-storage') as string);
    let customerData = mageCacheStorage.customer as CustomerData;

    // eslint-disable-next-line no-prototype-builtins
    if (!customerData || !customerData.hasOwnProperty('dataLayer')) {
        if (mageCacheStorage) {
            // get customer data of logged user from Magento
            const customerSectionsData = await to(getCustomerSections('customer'));
            const [, customerSectionsRes]: any = customerSectionsData;
            customerData = customerSectionsRes.customer;
            // update local storage
            mageCacheStorage.customer = customerData;
            localStorage.setItem('mage-cache-storage', JSON.stringify(mageCacheStorage));
            localStorage.setItem('ds-customer', JSON.stringify(customerData));
        }
    }

    return customerData;
}

function getGtmBaseEvent(isUserLoggedIn: boolean): Omit<GtmBaseEvent, 'event'> {
    return {
        logged_in: isUserLoggedIn,
        site_lang: store.state.options.locale,
        traffic_type: 'standard',
    };
}

/**
 * DataLayer event `init`
 */
export async function datalayerInitEvent(isUserLoggedIn: boolean) {
    const dataLayer: GtmBaseEvent = {
        ...getGtmBaseEvent(isUserLoggedIn),
        event: 'init',
    };

    if (isUserLoggedIn) {
        const customerData = await getLocalStorageCustomer();
        Object.assign(dataLayer, customerData.dataLayer);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayer);
}

export default {
    datalayerInitEvent,
};
